<!-- LoginPage.vue -->
<template>
  <div class="login-page">
    <div class="login-container">
      <div class="form-tabs">
        <div class="tab" :class="{ active: activeTab === 'login' }" @click="activeTab = 'login'">Login</div>
        <div class="tab" :class="{ active: activeTab === 'signup' }" @click="activeTab = 'signup'">Sign Up</div>
      </div>
      <div class="form-content">
        <div v-if="activeTab === 'login'" class="login-form">
          <h2>Login</h2>
          <form @submit.prevent="login">
            <div class="form-group">
              <label for="username">Email:</label>
              <input type="text" id="email" v-model="email" required :disabled="loading">
            </div>
            <div class="form-group">
              <label for="password">Password:</label>
              <input type="password" id="password" v-model="password" required :disabled="loading">
            </div>
            <div class="form-group">
              <router-link :to="{name: 'ForgetPassword'}">Forgot password?</router-link>
            </div>
            <button type="submit" :disabled="loading" class="login-button">
              <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ loading ? 'Logging in...' : 'Login' }}
            </button>
          </form>
          <p v-if="error" class="error-message">{{ error }}</p>
        </div>
        <div v-if="activeTab === 'signup'" class="signup-form">
          <h2>Sign Up</h2>
          <form @submit.prevent="signup">
            <div class="form-group">
              <label for="signup-username">Email:</label>
              <input type="text" id="signup-email" v-model="signupForm.email" required :disabled="loading">
            </div>
            <div class="form-group">
              <label for="signup-password">Password:</label>
              <input type="password" id="signup-password" v-model="signupForm.password" required :disabled="loading">
            </div>
            <div class="form-group">
              <label for="signup-confirm-password">Confirm Password:</label>
              <input type="password" id="signup-confirm-password" v-model="signupForm.confirmPassword" required
                     :disabled="loading">
            </div>
            <div class="form-group terms-group">
              <input type="checkbox" id="signup-terms" v-model="signupForm.agreeToTerms" required :disabled="loading">
              <label for="signup-terms">I agree to the terms and conditions</label>
            </div>
            <button type="submit" :disabled="loading" class="signup-button">
              <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ loading ? 'Signing up...' : 'Sign Up' }}
            </button>
          </form>
          <p v-if="error" class="error-message">{{ error }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {gsap} from 'gsap';

export default {
  data() {
    return {
      // Landing "Sign up free" links land on the signup tab via ?tab=signup.
      activeTab: this.$route.query.tab === 'signup' ? 'signup' : 'login',
      email: '',
      password: '',
      signupForm: {
        email: '',
        password: '',
        confirmPassword: '',
        agreeToTerms: false,
      },
    };
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'getErrorMessage', 'isLoading']),
    error() {
      return this.getErrorMessage;
    },
    loading() {
      return this.isLoading;
    },
  },
  mounted() {
    if (this.isAuthenticated) {
      this.finishLogin();
    }
  },
  methods: {
    ...mapActions('auth', ['loginUser', 'signupUser']),
    // Where to land after a successful login: the ?redirect= the caller asked
    // for, else the page the user came from, else the dashboard. Never a bare
    // "/profile" — signing in should continue whatever the user was doing.
    // Only same-origin paths are honored (an absolute URL in ?redirect= would
    // be an open redirect).
    finishLogin() {
      const redirectPath = this.$route.query.redirect;
      if (typeof redirectPath === 'string' && redirectPath.startsWith('/') && !redirectPath.startsWith('//')) {
        this.$router.push(redirectPath);
        return;
      }
      const back = this.$router.options.history.state.back;
      if (back && back !== this.$route.fullPath) {
        this.$router.back();
      } else {
        this.$router.push('/dashboard');
      }
    },
    async login() {
      try {
        const result = await this.loginUser({email: this.email, password: this.password});
        if (result === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
          console.log('Password reset required - redirecting to reset page');
          this.$router.push({name: 'PasswordReset', params: {resetMode: 'forced'}});
        } else if (result === "CONFIRM_SIGN_UP") {
          console.log('User not confirmed - redirecting to confirm page');
          this.$router.push({name: 'ConfirmSignup', query: {redirect: this.$route.query.redirect}});
        } else if (result) {
          this.finishLogin();
        }
      } catch (error) {
        console.error('Login error:', error);
      }
    },
    async signup() {
      try {
        const result = await this.signupUser(this.signupForm);
        if (result === "CONFIRM_SIGN_UP") {
          console.log('Signup started, need to confirm user now - redirecting to confirmation page');
          // Carry the redirect through confirmation so the post-signup login
          // still returns to where the user started.
          this.$router.push({name: 'ConfirmSignup', query: {redirect: this.$route.query.redirect}});
        }

      } catch (error) {
        console.error('Signup error:', error);
      }
    },
    animateInput(event) {
      const inputElement = event.target;
      const animationElement = inputElement.nextElementSibling;
      gsap.to(animationElement, {
        duration: 0.3,
        scaleX: 1,
        transformOrigin: 'left',
        ease: 'power1.out',
      });
    },
  },
  // watch: {
  //   activeTab(newTab, oldTab) {
  //     const formContent = this.$el.querySelector('.form-content');
  //     if (newTab === 'login') {
  //       gsap.fromTo(formContent, {x: oldTab === 'signup' ? '100%' : '-100%'}, {
  //         x: '0%',
  //         duration: 0.5,
  //         ease: 'power2.out'
  //       });
  //     } else if (newTab === 'signup') {
  //       gsap.fromTo(formContent, {x: oldTab === 'login' ? '-100%' : '100%'}, {
  //         x: '0%',
  //         duration: 0.5,
  //         ease: 'power2.out'
  //       });
  //     }
  //   },
  // },
};
</script>


<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: clamp(24px, 6vw, 64px) 20px;
  min-height: 60vh;
}

.login-container {
  max-width: 420px;
  width: 100%;
  padding: 32px;
  border-radius: var(--radius);
  background: var(--card);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
}

.form-tabs {
  display: flex;
  gap: 3px;
  padding: 4px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  margin-bottom: 24px;
}

.tab {
  flex: 1;
  text-align: center;
  padding: 8px 20px;
  cursor: pointer;
  background: transparent;
  color: var(--muted);
  border-radius: var(--radius);
  font-size: 13.5px;
  font-weight: 600;
  transition: .15s;
}

.tab.active {
  background: var(--card);
  color: var(--text);
  box-shadow: 0 1px 2px rgba(0, 0, 0, .06);
}

h2 { font-size: 26px; font-weight: 400; letter-spacing: -.01em; margin: 0 0 20px; }

.form-content { position: relative; }
.login-form, .signup-form { width: 100%; }

.form-group {
  position: relative;
  margin-bottom: 18px;
}

label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--muted);
}

input {
  width: 100%;
  padding: 11px 13px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
  background: var(--surface);
  color: var(--text);
  font-size: 14px;
  transition: border-color .15s, box-shadow .15s;
}

input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--ring);
}

button {
  display: block;
  width: 100%;
  padding: 12px;
  background: var(--accent);
  color: var(--on-accent);
  border: none;
  border-radius: var(--radius);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background-color .15s ease;
}

button:hover:not(:disabled) { background: var(--accent-h); }
button:disabled { opacity: .6; cursor: not-allowed; }

.error-message { color: var(--danger); margin-top: 10px; font-size: 13px; }

.signup-button { margin-top: 8px; }

a { color: var(--accent); text-decoration: none; font-weight: 600; font-size: 13px; }
a:hover { text-decoration: underline; }

.terms-group {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.terms-group input[type="checkbox"] {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1px solid var(--border-strong);
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
  transition: .15s;
}

.terms-group input[type="checkbox"]:checked {
  background: var(--accent);
  border-color: var(--accent);
}

.terms-group label {
  font-size: 13px;
  font-weight: 400;
  color: var(--muted);
  cursor: pointer;
  margin-bottom: 0;
}
</style>